<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-rate-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.rate.create') }}</h4>
        </template>
        <template v-slot:body>
            <RateForm :subscription-choice="true" :rate-prop="rate" @change="onChangeRate"></RateForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewRate(rate.type, rate.name, rate.duration_in_minutes, rate.max_participant, rate.max_participant_online, rate.price, rate.price_online, rate.appointment_count, rate.subscription_type_valid)">
                <i class="las la-check"></i>
                {{ $t('components.rate.create') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import {RATE_TYPE, RATE_TYPE_OPTIONS} from "../../common/constants";
    import {createRate} from "../../api";
    import RateForm from "../rate/RateForm";
    import ModalContainer from "./ModalContainer";
    export default {
        name: "AddRateModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                rate: {
                    id: null,
                    name: "",
                    type: RATE_TYPE.INDIVIDUAL,
                    duration_in_minutes: null,
                    max_participant: null,
                    max_participant_online: null,
                    price: null,
                    price_online: null,
                    price_currency: null,
                    appointment_count: 1,
                    subscription_type_valid: []

                },
                rateTypeOptions: RATE_TYPE_OPTIONS(),
                errorMessage: ""
            }
        },
        components: {RateForm, ModalContainer},
        methods: {
            async createNewRate(newRateType, newRateName, newRateDuration, newRateMaxParticipant, newRateMaxParticipantOnline, newRatePrice, newRatePriceOnline, newRateAppointmentCount, validForSubscription) {
                this.loading = true;
                try {
                    const resultRate = await createRate(newRateType, newRateName, newRateDuration, newRateMaxParticipant, newRateMaxParticipantOnline, newRatePrice, newRatePriceOnline, newRateAppointmentCount, validForSubscription);
                    this.loading = false;
                    this.$emit('close-rate-modal');
                    this.$nextTick(() => {
                        this.$router.push({ name: 'rate_detail', params: { id: resultRate.id }});
                    });


                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeRate(rate) {
                this.rate = rate;
            }
        }
    };
</script>
